(() => {
  'use strict';

// ======== video auto play ========
const v = document.getElementById('v');
const tryPlay = () => {
  if (!v) return;
  // iOS対策：属性も必須（HTML側で <video id="v" muted playsinline> 推奨）
  v.muted = true;
  v.play().catch(() => {});
};
document.addEventListener('DOMContentLoaded', tryPlay, { once: true });
document.addEventListener('touchstart', tryPlay, { once: true }); // iOS保険
document.addEventListener('visibilitychange', () => { if (!document.hidden) tryPlay(); });

// ======== Storyセクション・オーバーレイ ========================
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.lp-kotenbina-story__btn');
  const overlay = document.getElementById('story-overlay');
  const closeBtn = document.querySelector('.lp-kotenbina-story__overlay-close');
  const bg = document.querySelector('.lp-kotenbina-story__overlay-bg');
  const plus = document.querySelector('.lp-kotenbina-story__btn-icon');

  const lockScroll = (lock) => {
    document.documentElement.classList.toggle('is-modal-open', !!lock);
    document.body.classList.toggle('is-modal-open', !!lock);
  };

  const openOverlay = () => {
    if (!overlay) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    btn && btn.setAttribute('aria-expanded', 'true');
    // くるっと回るアニメ削除 → transform指定しない
    lockScroll(true);
  };

  const closeOverlay = () => {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    btn && btn.setAttribute('aria-expanded', 'false');
    // transformリセットも不要
    lockScroll(false);
  };

  btn && btn.addEventListener('click', openOverlay);
  closeBtn && closeBtn.addEventListener('click', closeOverlay);
  bg && bg.addEventListener('click', closeOverlay);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) {
      closeOverlay();
    }
  });
});

// ======== galleryセクション・オーバーレイ =======================
(() => {
  const overlay = document.querySelector('[data-gallery-overlay]');
  const openBtn = document.querySelector('[data-gallery-open]');
  const closeBtn = document.querySelector('[data-gallery-close]');
  if (!overlay || !openBtn || !closeBtn) return;

  const bg = overlay.querySelector('.lp-kotenbina-gallery__overlay-bg');

  const open = () => {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-modal-open');
  };
  const close = () => {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-modal-open');
  };

  openBtn.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  bg && bg.addEventListener('click', close);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });
})();

// ======== intro・collage フェードアップ ==========================
document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.fadeUp-on-scroll, .fadeUp-on-scroll--slow');
  if (!targets.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0 });

  targets.forEach(t => observer.observe(t));
});

})();